import * as React from "react";
import { css } from "@emotion/react";
import { useRouter } from "next/router";
import { Card } from "main/javascripts/components/card/Card";
import { CardTitle } from "main/javascripts/components/card/CardTitle";
import { CardImage } from "main/javascripts/components/card/CardImage";
import { StarNumRating } from "main/javascripts/components/StarRating/StarNumRating";
import { CardColumn } from "main/javascripts/components/card/CardColumn";
import { HotelIndexParam } from "main/javascripts/types/hotelIndexParam";
import { Hotel } from "main/javascripts/types/hotel";
import { hotelIndexParamToUrlParam } from "main/javascripts/slices/paramSlice";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import {
  borderColor,
  textColor,
} from "main/javascripts/styles/base/colorStyle";
import { moreThanBreakpoint } from "../../../../styles/base/responsiveStyle";

export interface IProps {
  hotel: Hotel.List;
  param: HotelIndexParam;
}

export const HotelRecommendedCard: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { hotel, param } = props;

  const router = useRouter();

  const onClick: () => void = () => {
    router.push(`/hotels/${hotel.id}?${hotelIndexParamToUrlParam(param)}`);
  };

  // nullにした方が良い?
  const url: string = hotel.defaultImage ? hotel.defaultImage.url : "";
  const rating: number = hotel.rating ? hotel.rating : 0;
  return (
    <div css={blockStyle}>
      <Card onClick={onClick}>
        <div css={imageBlockStyle}>
          <CardImage url={url} />
        </div>
        <div css={innerStyle}>
          <CardTitle>{hotel.name}</CardTitle>
          <div css={ratingBlockStyle}>
            {rating > 0 && (
              <div css={ratingStyle}>
                <StarNumRating rating={rating} />
              </div>
            )}
            <div css={rankTagStyle}>
              <span css={rankLabelStyle}>RANK</span>
              <span css={rankValueStyle}>{hotel.rank}</span>
            </div>
          </div>
          <div css={roomBlockStyle}>
            <CardColumn>
              <div css={roomInfoStyle}>
                <div css={recommendedSentenceStyle}>
                  {hotel.hotelRecommendedSentences &&
                    hotel.hotelRecommendedSentences.map(
                      (sentence: string, index: number) => {
                        return <p key={index}>{sentence}</p>;
                      }
                    )}
                </div>
              </div>
            </CardColumn>
          </div>
        </div>
      </Card>
    </div>
  );
};

const blockStyle = css`
  cursor: pointer;
`;
const innerStyle = css`
  flex: 1;
  padding: ${space.atom2x} ${space.atom};
`;
const imageBlockStyle = css`
  aspect-ratio: 2 / 1;
  overflow: hidden;
  ${moreThanBreakpoint("tablet")} {
    aspect-ratio: auto;
    height: auto;
    width: 33.333%;
  }
`;
const ratingStyle = css`
  padding: ${space.atom0_5x} ${space.atom} ${space.atom};
`;
const roomBlockStyle = css`
  align-items: center;
  &:before {
    content: "";
    border-top: 1px solid ${borderColor.primaryLightColor};
    display: block;
    width: 100%;
    margin: ${space.atom1_5x} ${space.atom} 0;
    padding: ${space.atom} 0 0;
  }
`;
const roomInfoStyle = css`
  width: 100%;
`;
const rankTagStyle = css`
  font-size: ${fontSize.caption};
  padding: 0 0.25rem;
  background: ${borderColor.primaryDarkColor};
  color: #fff;
  margin: 0 ${space.atom} 0.3rem;
  align-self: center;
  border-radius: 2px;
`;
const rankLabelStyle = css`
  vertical-align: middle;
  padding-right: 0.3rem;
  font-size: ${fontSize.smallest};
`;
const rankValueStyle = css`
  vertical-align: middle;
`;
const ratingBlockStyle = css`
  display: flex;
`;
const recommendedSentenceStyle = css`
  padding: ${space.atom};
  color: ${textColor.secondaryDarkColor};
  font-size: ${fontSize.body};
  line-height: ${lineHeight.body2};
`;
